import script from "./Reservations.vue?vue&type=script&setup=true&lang=ts"
export * from "./Reservations.vue?vue&type=script&setup=true&lang=ts"

import "./Reservations.vue?vue&type=style&index=0&id=771b4a71&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-771b4a71"]])

export default __exports__